export default __webpack_public_path__ + "static/use_case_messaging-bbab18ff6f9851eafcda5b49b087ebb3.gif";